import { Link , useNavigate} from "react-router-dom";

export default function PageNotFound() {
    const navigate=useNavigate()
  return (
    <div style={{fontFamily: "ui-sans-serif, system-ui, sans-serif"}} className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#F2E9FF] via-[#E9EDFF] to-white">
    <h1 className="text-7xl font-extrabold text-[#5B4BFF]">404</h1>
    <p  style={{fontFamily: "Inter sans-serif"}} className="text-[#475569]  mt-4">
      The page you’re looking for doesn’t exist.
    </p>
    <button onClick={()=>{

        const IsLoggedIn=localStorage.getItem("isLoggedIn")
        {IsLoggedIn?navigate("/dashboard"):navigate("/")}
        
    }} style={{fontFamily: "Inter sans-serif"}} className="mt-6 px-6 py-3 rounded-full text-sm bg-gradient-to-r from-[#5B4BFF] to-[#B84BFF] text-white font-semibold">
      Go To Home
    </button>
  </div>

  );
}




